// Define the initial state for the reducer
const initialState = {
    ars_filter_object: {
        DimensionKey: {
            period: null,
            product: null,
            location: null,
        },
        DimensionValues: {
            product: null,
            location: null,
            period: null,
        },
        slec: null,
    },
    process: null,
};

const UPDATE_ARS_DATA = (state = initialState, action) =>{
    switch(action.type){
        case 'UPDATE_PROCESS' : 
            return {...state , process : action.payload }
            case 'SET_ARS_SELECTION_ID' : 
            return {   
                ...state,
                ars_filter_object: {
                    ...state.ars_filter_object,
                    slec:action.payload
                }
            };  
            case 'SET_ARS_PERIOD_BUCKET' : 
            return {   
                ...state,
                ars_filter_object: {
                    ...state.ars_filter_object,
                    DimensionKey: {
                        ...state.ars_filter_object.DimensionKey,
                        period: action.payload,
                    }
                }
            };                            
        case 'SET_ARS_PRODUCT_LAVAL' : 
        return {   
            ...state,
            ars_filter_object: {
                ...state.ars_filter_object,
                DimensionKey: {
                    ...state.ars_filter_object.DimensionKey,
                    product: action.payload,
                }
            }
        };  
        case 'SET_ARS_LOCATION_LAVAL' : 
                return {   
                    ...state,
                    ars_filter_object: {
                        ...state.ars_filter_object,
                        DimensionKey: {
                            ...state.ars_filter_object.DimensionKey,
                            location: action.payload,
                        }
                    }
                };        
        case 'UPDATE_ARS_FILTER_OBJECT' : 
            return {...state , ars_filter_object : action.payload}
        case 'SET_ARS_PRODUCTS':
                return {   
                    ...state,
                    ars_filter_object: {
                        ...state.ars_filter_object,
                        DimensionValues: {
                            ...state.ars_filter_object.DimensionValues,
                            product: action.payload,
                        }
                    }
                };    
                case 'SET_ARS_LOCATIONS':
                    return {   
                        ...state,
                        ars_filter_object: {
                            ...state.ars_filter_object,
                            DimensionValues: {
                                ...state.ars_filter_object.DimensionValues,
                                location: action.payload,
                            }
                        }
                    };     
                    case 'SET_ARS_PERIOD':
                        return {   
                            ...state,
                            ars_filter_object: {
                                ...state.ars_filter_object,
                                DimensionValues: {
                                    ...state.ars_filter_object.DimensionKey,
                                    period: action.payload,
                                }
                            }
                        }; 
                        case 'SET_ARS_PERIOD_LIST':
                            return {   
                                ...state,
                                ars_filter_object: {
                                    ...state.ars_filter_object,
                                    DimensionValues: {
                                        ...state.ars_filter_object.DimensionValues,
                                        period: action.payload,
                                    }
                                }
                            };                 
        default : return state
    }
}


export {UPDATE_ARS_DATA}